<template>
    <div>
        <div>
            <a :id='service.name' :href='linkon()' target="_blank"  v-if="service.form == undefined" v-on:click='markuse'>
                <div class="service">
                    <img :src="service.imagepath" width="90%" class="serviceimage">
                    <div class="overlay"></div>
                    <h3 class="servicetextcolor">{{service.displayname}}</h3>
                </div>
            </a>
            <a :id='service.name' v-on:click="linkonform" v-if="service.form != undefined">
                <div class="service">
                    <img :src="service.imagepath" width="90%" class="serviceimage">
                    <div class="overlay"></div>
                    <h3 class="servicetextcolor">{{service.displayname}}</h3>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
const $ = require('jquery')
window.$ = $

function LoginToService (url, p) {
    var myForm = document.createElement("form");
    myForm.target = "_blank";
    myForm.method = "post" ;
    myForm.action = url ;
    for (var k in p) {
        var myInput = document.createElement("input") ;
        myInput.setAttribute("name", k) ;
        myInput.setAttribute("value", p[k]);
        myForm.appendChild(myInput) ;
    }
    document.body.appendChild(myForm);
    myForm.submit()
    document.body.removeChild(myForm);
}

export default {
    props: ['service', 'enabled'],
    name: 'servicepage',
    data: function () {
        return {

        }
    },
    components: {
        
    },
    methods: {
        linkonform: function() {
            if (this.enabled == true) {
                if (this.service.form != undefined) {
                    this.markuse();
                    LoginToService(this.service.form.url, this.service.form.p);
                }
            } else {
                return "javascript:alert('Not available outside the intranet, use a VPN')";    
            }
        },
        linkon: function() {
            if (this.enabled == true) {
                return this.service.mappedurl;
            } else {
                return "javascript:alert('Not available outside the intranet, use a VPN')";    
            }
        },
        markuse: function() {
            $.post("/service/markuse", {"servicename": this.service.name}).done(function() {})
        }
    },
    beforeMount: function () {
  
    },
    mounted: function () {

    },
    updated: function () {
        
    }
}
</script>

<style>
.service {
    height: 100%;
    /*background-image: linear-gradient(to top, #c4c5c7 0%, #dcdddf 52%, #ebebeb 100%);*/
    background-color: rgba(255,255,255,0.0);
    text-align: center;
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 20px;
    cursor: pointer;
}
.servicetextcolor {
    color: white;
    font-family: "MuseoSans300", normal !important;
    margin-top: 25px;
}

.service:hover {
    background-color: rgba(255,255,255,0.2);
}
.divshadow {
  box-shadow: 0 5px 8px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}

.divshadow:hover {
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
}

.serviceimage {
    /*-webkit-filter: grayscale(50%); 
    filter: grayscale(50%);*/
    border-radius: 50%; 
    /*border: 2px solid lightgray;*/
}

.serviceimage:hover {
    -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
    filter: grayscale(0%);
}


</style>